var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext } from 'react';
import mergeClassnames from '../../../mergeClassnames/mergeClassnames';
import GenericSearch from '../../../private/icons/GenericSearch';
import { SearchContext } from '../utils/context';
const Wrapper = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: mergeClassnames('flex items-center ps-3 gap-2 moon-search-input', className) }, props), children));
};
const Icon = (_a) => {
    var { children, className } = _a, props = __rest(_a, ["children", "className"]);
    return (React.createElement(GenericSearch, Object.assign({ className: mergeClassnames('w-6 h-6 pointer-events-none text-bulma', className) }, props)));
};
const InnerInput = forwardRef((_a, ref) => {
    var { placeholder, autoFocus, className } = _a, props = __rest(_a, ["placeholder", "autoFocus", "className"]);
    const { search, onChangeOpen, onChangeSearch, inputRef } = useContext(SearchContext);
    const ariaLabelValue = props['aria-label'] ? props['aria-label'] : 'Search';
    return (React.createElement("input", Object.assign({ ref: (ref || inputRef), spellCheck: false, className: mergeClassnames('moon-search-input py-2 px-0 border-0 w-full focus:outline-none focus:border-0', 'focus:ring-0 bg-transparent placeholder-bulma text-bulma', className), onClick: () => {
            onChangeOpen(true);
        }, onChange: (e) => {
            onChangeSearch(e.currentTarget.value);
        }, onFocus: (e) => {
            e.currentTarget.select();
            onChangeOpen(true);
        }, onKeyDown: (e) => {
            if (e.key === 'Escape' && search) {
                e.preventDefault();
                e.stopPropagation();
                onChangeSearch('');
            }
        }, placeholder: placeholder, value: search, type: "text", autoFocus: autoFocus, autoComplete: "off", "aria-label": ariaLabelValue }, props)));
});
export const ButtonClear = (_a) => {
    var { children, className, onClick } = _a, props = __rest(_a, ["children", "className", "onClick"]);
    const { onChangeSearch } = useContext(SearchContext);
    return (React.createElement("button", Object.assign({ tabIndex: -1, type: "button", className: mergeClassnames('cursor-pointer text-trunks text-moon-14 transition absolute end-4', 'top-1/2 transform -translate-y-1/2', className), onClick: (e) => {
            var _a;
            onChangeSearch('');
            const inputElement = (_a = e.currentTarget.parentNode) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.moon-search-input')[0];
            if (inputElement) {
                inputElement.focus();
            }
            if (typeof onClick === 'function') {
                onClick(e);
            }
        } }, props), children));
};
export const Input = Object.assign(Wrapper, {
    Icon,
    Input: InnerInput,
    ButtonClear,
});
